import Actions from '../constants/Actions';
const TIMEOUT = 200000;
var cookie = require('react-cookie');
//var curl = require('curlrequest');
//var cookie = require('react-cookie');
const loginServiceCreator = {
  loginservice(context, response, done) {
    /*var logindata = {
    	email: response.email
    };*/

  },

  checkUserRegister(context, content, done) {
    context.service.read('userservice', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        if (data.length !== 0) {
          content.id = data[0].id;
          content.fblogin = 1;
          loginServiceCreator.updateSession(context, content, done).then(function() {
            console.log('updated the session');
          });
        } else {
          loginServiceCreator.registerUser(context, content, done)
            .then(function() {
              return loginServiceCreator.updateSession(context, content, done);
            });
        }
        var nextpage = cookie.load('referrer');
          cookie.save('referrer', '', {
            expires: new Date(),
            httpOnly: false,
            path: '/'
          });

        cookie.save('logged_in', 2, {
          path: '/'
        });

        $(".whirly-loader").css('visibility', 'hidden');
       window.location = nextpage;
      }
    );

  },

  registerUser(context, content, done) {
    return new Promise(function(resolve, reject) {
      context.service.create('userservice', content, {
        timeout: TIMEOUT
      },
        (err, data) => {
          if (err) {
            done(err);
            reject(err);
          }
          done();
          resolve();
        }
      );
    });
  },
  signin(context, content, done) {
    context.service.read('signinservice', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        if (data.length === 0) {
          $('.login-error').text("The email and password you entered does not match.");
        } else {
          $('.login-error').text("");
          content.folink_username = data[0].folink_username;
          content.id = data[0].id;
          loginServiceCreator.updateSession(context, content, done);
          var predict = {};
          predict.ids = '';
          $('.input-email').val('');
          $('.input-pass').val('');
          var nextpage = cookie.load('referrer');
          cookie.save('referrer', '', {
            expires: new Date(),
            httpOnly: false,
            path: '/'
          });
          window.location = nextpage;
        }
        $(".whirly-loader").css('visibility', 'hidden');
      }
    );
  },
  signup(context, content, done) {
    context.service.read('userservice', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        if (data.length !== 0) {
          $('#email-err').text("This email is already exists.");
          $(".formEmail").focus();
          $(".whirly-loader").css('visibility', 'hidden');
          return false;
        } else {
          content.id = Math.random().toString(36).slice(2);
          loginServiceCreator.registerUser(context, content, done)
            .then(function() {
              return loginServiceCreator.updateSession(context, content, done);
            });
            var nextpage = cookie.load('referrer');
          cookie.save('referrer', '', {
            expires: new Date(),
            httpOnly: false,
            path: '/'
          });

          window.location = nextpage;
        }
      }
    );
  },
  checkUser(context, content, done) {
    content.operation = 'checkusername';
    context.service.read('userservice', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        if (data.length !== 0) {
          alert("This username is already exists. Please try different one!");
        } else {
        }
        $(".whirly-loader").css('visibility', 'hidden');
      }
    );
  },
  checkSessionStatus(context, content, done) {
    content.user_id = cookie.load('id', true);
    context.service.read('loginservice', {
      'id': content.id
    }, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          return done(err);
        }
        done(data);
      }
    );
  },
  createProfile(context, content, done) {
    return new Promise(function(resolve, reject) {
      context.service.create('profileservice', content, {
        timeout: TIMEOUT
      },
        (err, data) => {
          if (err) {
            done(err);
            reject(err);
          }
          done();
          resolve();
        }
      );
    });
  },
  createReview(context, content, done) {
    return new Promise(function(resolve, reject) {
      context.service.create('reviewservice', content, {
        timeout: TIMEOUT
      },
        (err, data) => {
          if (err) {
            done(err);
            reject(err);
          }
          done();
          resolve();
          $(".whirly-loader").css('visibility', 'visible');
          location.reload();
        }
      );
    });
  },
  createReplyReview(context, content, done) {
    return new Promise(function(resolve, reject) {
      context.service.create('reviewreplyservice', content, {
        timeout: TIMEOUT
      },
        (err, data) => {
          if (err) {
            done(err);
            reject(err);
          }
          done();
          resolve();
          $(".whirly-loader").css('visibility', 'visible');
          location.reload();
        }
      );
    });
  },
  createSession(context, content, done) {
    loginServiceCreator.checkSessionStatus(context, content, function(sessiondata) {
      if (sessiondata.length === 0) {
        context.service.create('loginservice', content, {
          timeout: TIMEOUT
        },
          (err, data) => {
            if (err) {
              return done(err);
            }
            done();
          }
        );
      }
    });
  },
  updateSession(context, content, done) {
    return new Promise(function(resolve, reject) {
      context.service.update('loginservice', content, {
        timeout: TIMEOUT
      },
        (err, data) => {
          if (err) {
            done(err);
            reject(err);
          }
          context.dispatch(Actions.SESSION_UPDATE_SUCCESS, content);
          done();
          resolve();
        }
      );
    });
  },
  UserLogout(context, content, done) {
    context.service.update('loginservice', content, {
      timeout: TIMEOUT
    },
      (err, data) => {
        if (err) {
          done(err);
        }
        context.dispatch(Actions.LOGOUT_SUCCESS, content);
        done();
      }
    );
  },
  CreateEntertainer(context, content, done) {
    var id = content.id;
    var nationality = content.nationality;
    var age = content.age;
    var gender = content.gender;
    return new Promise(function(resolve, reject) {
      context.service.create('entertainerservice', content, {
        timeout: TIMEOUT
      },
        (err, data) => {
          if (err) {
            done(err);
            reject(err);
          }
          console.log("data",data);
           $(".whirly-loader").css('visibility', 'hidden');
           $('.signup-form')[0].reset();
            window.location.href='/searchResults?id='+data.id+ '&nationality='+data.nationality+'&age='+data.age+'&gender='+data.gender+'';

          done();
          resolve();
          // $(".whirly-loader").css('visibility', 'visible');
          // location.reload();

        }
      );
    });
  }
};
export default loginServiceCreator;



// WEBPACK FOOTER //
// ./src/actions/LoginServiceCreator.js